// src/store/actions/tagActions.js
import { TAG_ACTIONS } from './actionTypes';
import tagService from '../../services/tagService';

// Fetch tags
export const fetchTags = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: TAG_ACTIONS.FETCH_TAGS_REQUEST });

    const response = await tagService.getTags(params);
    
    dispatch({
      type: TAG_ACTIONS.FETCH_TAGS_SUCCESS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: TAG_ACTIONS.FETCH_TAGS_FAILURE,
      payload: error.message || 'Failed to fetch tags',
    });
  }
};

// Fetch single tag
export const fetchTag = (id) => async (dispatch) => {
  try {
    dispatch({ type: TAG_ACTIONS.FETCH_TAG_REQUEST });

    const response = await tagService.getTagById(id);
    
    dispatch({
      type: TAG_ACTIONS.FETCH_TAG_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: TAG_ACTIONS.FETCH_TAG_FAILURE,
      payload: error.message || 'Failed to fetch tag',
    });
    throw error;
  }
};

// Create tag
export const createTag = (tagData) => async (dispatch) => {
  try {
    dispatch({ type: TAG_ACTIONS.CREATE_TAG_REQUEST });

    const response = await tagService.createTag(tagData);
    
    dispatch({
      type: TAG_ACTIONS.CREATE_TAG_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: TAG_ACTIONS.CREATE_TAG_FAILURE,
      payload: error.message || 'Failed to create tag',
    });
    throw error;
  }
};

// Update tag
export const updateTag = (id, tagData) => async (dispatch) => {
  try {
    dispatch({ type: TAG_ACTIONS.UPDATE_TAG_REQUEST });

    const response = await tagService.updateTag(id, tagData);
    
    dispatch({
      type: TAG_ACTIONS.UPDATE_TAG_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: TAG_ACTIONS.UPDATE_TAG_FAILURE,
      payload: error.message || 'Failed to update tag',
    });
    throw error;
  }
};

// Delete tag
export const deleteTag = (id) => async (dispatch) => {
  try {
    dispatch({ type: TAG_ACTIONS.DELETE_TAG_REQUEST });

    const response = await tagService.deleteTag(id);
    
    dispatch({
      type: TAG_ACTIONS.DELETE_TAG_SUCCESS,
      payload: { id, message: response.message },
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: TAG_ACTIONS.DELETE_TAG_FAILURE,
      payload: error.message || 'Failed to delete tag',
    });
    throw error;
  }
};

// Get tag stats
export const fetchTagStats = (id) => async (dispatch) => {
  try {
    dispatch({ type: TAG_ACTIONS.FETCH_TAG_STATS_REQUEST });

    const response = await tagService.getTagStats(id);
    
    dispatch({
      type: TAG_ACTIONS.FETCH_TAG_STATS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: TAG_ACTIONS.FETCH_TAG_STATS_FAILURE,
      payload: error.message || 'Failed to fetch tag stats',
    });
  }
};

// Get popular tags
export const fetchPopularTags = (limit = 20) => async (dispatch) => {
  try {
    dispatch({ type: TAG_ACTIONS.FETCH_POPULAR_TAGS_REQUEST });

    const response = await tagService.getPopularTags(limit);
    
    dispatch({
      type: TAG_ACTIONS.FETCH_POPULAR_TAGS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: TAG_ACTIONS.FETCH_POPULAR_TAGS_FAILURE,
      payload: error.message || 'Failed to fetch popular tags',
    });
  }
};

// Bulk delete tags
export const bulkDeleteTags = (ids) => async (dispatch) => {
  try {
    dispatch({ type: TAG_ACTIONS.BULK_DELETE_TAGS_REQUEST });

    const response = await tagService.bulkDeleteTags(ids);
    
    dispatch({
      type: TAG_ACTIONS.BULK_DELETE_TAGS_SUCCESS,
      payload: response,
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: TAG_ACTIONS.BULK_DELETE_TAGS_FAILURE,
      payload: error.message || 'Failed to bulk delete tags',
    });
    throw error;
  }
};

// Merge tags
export const mergeTags = (sourceTagId, targetTagId) => async (dispatch) => {
  try {
    dispatch({ type: TAG_ACTIONS.MERGE_TAGS_REQUEST });

    const response = await tagService.mergeTags(sourceTagId, targetTagId);
    
    dispatch({
      type: TAG_ACTIONS.MERGE_TAGS_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: TAG_ACTIONS.MERGE_TAGS_FAILURE,
      payload: error.message || 'Failed to merge tags',
    });
    throw error;
  }
};

// Set tag filters
export const setTagFilters = (filters) => ({
  type: TAG_ACTIONS.SET_TAG_FILTERS,
  payload: filters,
});

// Clear error
export const clearTagError = () => ({
  type: TAG_ACTIONS.CLEAR_TAG_ERROR,
});

// Clear success
export const clearTagSuccess = () => ({
  type: TAG_ACTIONS.CLEAR_TAG_SUCCESS,
});

// Clear selected tag
export const clearSelectedTag = () => ({
  type: TAG_ACTIONS.CLEAR_SELECTED_TAG,
});